// i18n
import { i18n } from '@ecg-internal/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import prices from '../../../../locales/nl-BE/prices.json';
import common from '../../../../locales/nl-BE/common.json';

export default i18n.init({
  lng: 'nl-BE',
  translations: {
    translation,
    prices,
    common,
  },
  dateLocale,
});
